/**
 * LiquidGlassFilter
 *
 * Hidden SVG that defines a displacement map filter for liquid glass refraction.
 * Must be rendered once in the DOM (e.g. in root layout) so CSS can reference
 * `backdrop-filter: url(#liquidGlassFilter) blur(…)`.
 *
 * Pipeline:
 *   feTurbulence → feColorMatrix (30° rotation) → feDisplacementMap
 */

import React from "react";

export function LiquidGlassFilter() {
  return (
    <svg
      aria-hidden="true"
      style={{
        position: "absolute",
        width: 0,
        height: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <filter
        id="liquidGlassFilter"
        x="-10%"
        y="-10%"
        width="120%"
        height="120%"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.012 0.018"
          numOctaves={3}
          seed={2}
          result="noise"
        />

        <feColorMatrix
          in="noise"
          type="matrix"
          values="0.866 0.5 0 0 0
                  -0.5 0.866 0 0 0
                  0 0 1 0 0
                  0 0 0 1 0"
          result="rotatedNoise"
        />

        <feDisplacementMap
          in="SourceGraphic"
          in2="rotatedNoise"
          scale={18}
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
    </svg>
  );
}
